import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { askNobiRoutes } from "./routes";

export const askNobiRoute = [
  {
    path: askNobiRoutes.chat,
    lazy: async () => {
      const { AskNobiChatPage } = await import("./pages/ask-nobi-chat/AskNobiChatPage");

      return { element: <AskNobiChatPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
